import { LESSONS } from './script';

/** Nine lesson pips for the top bar (docs/HINTS-LAYOUT-TUTORIAL.md B7). */
export function Progress({ lesson }: { lesson: number }) {
  return (
    <span className="tut-progress" role="img" aria-label={`Lesson ${lesson} of ${LESSONS}`}>
      {Array.from({ length: LESSONS }, (_, i) => (
        <i key={i} className={i + 1 < lesson ? 'done' : i + 1 === lesson ? 'now' : ''} />
      ))}
    </span>
  );
}
